export default {
  pageTitle: 'Blog',
  pageSubtitle: 'Expert tips and guides for pet care',
  searchPlaceholder: 'Search articles...',
  categories: {
    all: 'All Articles',
    health: 'Health',
    nutrition: 'Nutrition',
    training: 'Training',
    grooming: 'Grooming',
    lifestyle: 'Lifestyle',
    news: 'News'
  },
  sortNewest: 'Newest First',
  sortOldest: 'Oldest First',
  readMore: 'Read Article',
  minutesRead: 'min read',
  noArticlesFound: 'No articles found',
  noArticlesDescription: 'Try adjusting your search or filter criteria',
  clearFilters: 'Clear All Filters',
  backToBlog: 'Back to Blog',
  shareArticle: 'Share',
  relatedArticles: 'Related Articles',
  tags: 'Tags',
  featured: 'Featured',
  article: 'Article',
  articles: 'Articles',
  showing: 'Showing',
  tableOfContents: 'Table of Contents'
};